<template>
  <div id="showroom-personalization">
    <div class="personalizations-wrapper" v-if="player2dReady">
      <div class="wrapper">
        <section class="team-colors sidebar-option-title">
          <label class="sidebar-option-title">Colors</label>
          <div class="color-pickers-container">
            <ColorPicker
              :colorPickerMode="colorPickerMode"
              :colorsToChange="colorsToChange"
              @selectColor="handleSelectColor"
            />
          </div>
        </section>
        <section>
          <label class="sidebar-option-title">Team Name</label>
          <input
            class="input-style form-control"
            v-model="mascot"
            maxlength="20"
          />
        </section>

        <section class="logo-wrapper">
          <template v-if="!loadingState && !editableLogo.content">
            <!-- Upload input -->
            <label class="sidebar-option-title">Upload Team Logo</label>
            <UploadLogoButton
              :graphicButtonHint="'Upload Your Logo'"
              :hideInput="false"
              :hasCustomer="false"
              :type="typeOfLogo"
            />
          </template>
          <template v-else-if="editableLogo.content">
            <template>
              <div
                class="logo-image-container d-flex justify-content-center align-center"
              >
                <img
                  :src="editableLogo.content"
                  alt="logo"
                  v-if="editableLogo"
                />
              </div>
            </template>
            <template>
              <div class="logo-actions">
                <button
                  title="edit logo"
                  class="btn"
                  @click="handleEditLogo()"
                >
                  <img
                    src="@/assets/icons/ui/pencil-outline-dark.svg"
                    alt="edit logo"
                  />
                </button>
                <img
                  src="@/assets/icons/ui/trash-outline-red.svg"
                  alt="delete"
                  v-if="editableLogo.content"
                  class="flaticon-circle"
                  id="remove-logo"
                  @click.stop="
                    emitRemoveLogo({
                      logoId: editableLogo && editableLogo.id,
                      typeOfLogo,
                    })
                  "
                  title="Remove logo"
                  tabindex="0"
                />
              </div>
            </template>
            <transition name="fade">
              <UploadLogosModal @saveLogo="handleSaveLogo"
            /></transition>
          </template>
          <template v-else-if="loadingState">
            <Loader />
          </template>
        </section>
      </div>
      <div class="wrapper">
        <div id="design-preview">
          <Product
            :product="activeProduct"
            :originalProduct="activeProduct"
            :withImage="true"
            :productActionsCentered="true"
            :showBrand="true"
            :showShowroomPrice="false"
            :withDescription="false"
            :designName="activeProduct.designName"
            :forcedLocationName="forcedLocationName"
          />
        </div>
      </div>
    </div>
    <template v-else>
      <Loader />
    </template>
    <section class="path-navigation">
      <div class="navigation-divider">&nbsp;</div>
      <div class="path-actions">
        <div class="path-hint">NEXT STEP</div>
        <div
          class="path-action"
          :class="{ 'path-action-disabled': !actionEnabled }"
          @click="handleConfirmation()"
        >
          CHOOSE YOUR PRODUCTS
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5625 5.25L19.3125 12L12.5625 18.75"
              stroke="#FFFFFF"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.375 12H4.6875"
              stroke="#FFFFFF"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ColorPicker from "@/components/Projects/Project/Colors/ColorPicker.vue";
import UploadLogoButton from "@/components/Utils/Logos/UploadLogoButton.vue";
import Loader from "@/components/Utils/Loader.vue";
import Product from "@/components/Projects/Product/Product";
import UploadLogosModal from "@/components/Utils/Logos/UploadLogosModal";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "Personalizations",

  computed: {
    ...mapState("project", ["uniformMascot"]),
    ...mapState("uploadLogos", ["loadingState", "editableLogo"]),
    ...mapGetters("project", ["projectColors"]),
    ...mapState("threekit", ["cachedTKData"]),
    ...mapState("showroom", ["showroomPath", "player2dReady"]),

    refName() {
      return this.defaultLogoToBeSelected + "-default-upload-btn";
    },

    actionEnabled() {
      return this.mascot.length > 0 && !this.loadingState;
    },

    activeProduct() {
      //TODO
      return this.landingProducts.find((p) => {
        return p.page === this.showroomPath;
      });
    },

    colorPickerMode() {
      return "multiple";
    },

    forcedLocationName() {
      if (this.showroomPath === "school" || this.showroomPath === "team") {
        return "Baseball Home";
      }
      return "Center Chest Home";
    },

    colorsToChange() {
      return this.projectColors;
    },

    isProductInThreekit() {
      return this.cachedTKData.products?.[this.activeProduct?.style_id];
    },
  },

  methods: {
    ...mapActions("showroom", ["updateShowroomColor", "updateMascotAndColors"]),
    ...mapActions("uploadLogos", ["closeEditLogoModal", "setEditableLogo", "openEditLogoModal"]),
    ...mapActions("threekit", ["initProductCache", "changeLogo"]),
    ...mapActions("project", [
      "updateDecorationsForCustomLayouts",
      "initWindowThreekitPlayer",
    ]),

    async handleSelectColor({ color, colorKey }) {
      await this.updateShowroomColor({
        colorId: color?.id,
        colorKey,
        ignoreDecoration: true,
      });
      this.updateDecoration();
    },

    /*emitUploadingDefaultLogo(payload) {
      console.log("emitUploadingDefaultLogo", payload);
    },

    emitDefaultLogoHasBeenUploaded(payload) {
      //await this.setNewDefautlLogo(logoId);
      console.log("emitDefaultLogoHasBeenUploaded", payload);
    },

    emitOpenManageLogosModal(payload) {
      console.log("emitOpenManageLogosModal", payload);
    },

    handleLogoHasBeenUploaded(payload) {
      console.log(payload)
    },*/

    emitRemoveLogo() {
      //      this.$emit("removeLogo", { logoId, typeOfLogo });
      this.closeEditLogoModal();
    },

    handleEditLogo() {
      this.openEditLogoModal()
    },

    handleConfirmation() {
      if (!this.actionEnabled) return false;
      this.updateMascotAndColors({ mascot: this.mascot.trim() });
      this.$emit("updatePersonalization", true);
    },

    initLandingProducts() {
      for (let index = 0; index < this.landingProducts.length; index++) {
        const prod = this.landingProducts[index];

        this.initProductCache({
          styleName: prod.style_id,
          designName: prod.designName,
        });
      }
    },

    async handleSaveLogo(logo) {
      console.log("save", logo);
      await this.setEditableLogo(logo.logo);
      console.log("save regen logo")
      setTimeout(() => {
        this.updateDecoration()
      }, 5000);

      
    },

    updateDecoration() {
      this.updateDecorationsForCustomLayouts({
        configurationName: this.forcedLocationName,
        mascot: this.mascot,
      });
    },
  },

  watch: {
    mascot() {
      const graphic = this.editableLogo;
      const hasGraphic = graphic != null && graphic.asset_id != null;
      //TODO add throthle?

      //check if graphic has number, if not dont trigger
      if (!hasGraphic) {
        this.updateDecoration();
      }
    },

    player2dReady() {
      this.updateDecoration();
    },

    editableLogo: {
      handler() {
        this.updateDecoration();
      },
      deep: true,
    },
  },

  async mounted() {
    await this.initLandingProducts();
    this.$emit("updatePersonalizationsTab", "personalizations");
    this.mascot = this.uniformMascot;
    setTimeout(() => {
      if (this.player2dReady) this.updateDecoration();
    }, 1000);
  },

  data() {
    return {
      mascot: "",
      typeOfLogo: "upload",
      landingProducts: [
        {
          page: "school",
          style_id: "JBJC1A",
          designName: "FULL COUNT",
        },
        {
          page: "team",
          style_id: "JBJC1A",
          designName: "FULL COUNT",
        },
        {
          page: "organization",
          style_id: "BS0001",
          designName: "OLD SCHOOL",
        },
        {
          page: "other",
          style_id: "BS0001",
          designName: "OLD SCHOOL",
        },
        {
          page: "event",
          style_id: "BS0001",
          designName: "OLD SCHOOL",
        },
      ],
    };
  },

  components: {
    ColorPicker,
    UploadLogoButton,
    Loader,
    Product,
    UploadLogosModal,
  },
};
</script>

<style lang="scss" scoped>
#showroom-personalization {
  display: flex;
  flex-direction: column;
  align-items: center;

  .personalizations-wrapper {
    display: flex;
    width: 100%;
    align-items: center;

    .wrapper {
      width: 50%;
      max-width: 320px;
    }

    .logo-wrapper {
      position: relative;
      margin-top: 1em;

      .logo-image-container {
        width: 75%;
        border-radius: 3px;
        border: 1px solid #e2e5ec;
        min-height: 100px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC);

        > img {
          max-width: 100%;
          max-height: 150px;
        }
      }

      .logo-actions {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        #remove-logo {
          cursor: pointer;
        }
      }
    }
  }
}
</style>